import { BaseApi } from './base.api.js';

export class BiaApi extends BaseApi {
    constructor(client) {
        super(client, '/bia');
    }

    getStats() {
        return this.client.get(`${this.basePath}/stats`);
    }

    async getRelatedProcesses(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/processes`, { params });
        return response.data;
    }

    async addProcesses(id, processIds) {
        const response = await this.client.post(`${this.basePath}/${id}/processes`, { processIds });
        return response.data;
    }

    async removeProcess(id, processId) {
        const response = await this.client.delete(`${this.basePath}/${id}/processes/${processId}`);
        return response.data;
    }

    async getRelatedAssets(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/assets`, { params });
        return response.data;
    }

    async addAssets(id, assetIds) {
        const response = await this.client.post(`${this.basePath}/${id}/assets`, { assetIds });
        return response.data;
    }

    async removeAsset(id, assetId) {
        const response = await this.client.delete(`${this.basePath}/${id}/assets/${assetId}`);
        return response.data;
    }

    async getRelatedVendors(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/vendors`, { params });
        return response.data;
    }

    async addVendors(id, vendorIds) {
        const response = await this.client.post(`${this.basePath}/${id}/vendors`, { vendorIds });
        return response.data;
    }

    async removeVendor(id, vendorId) {
        const response = await this.client.delete(`${this.basePath}/${id}/vendors/${vendorId}`);
        return response.data;
    }

    async getRelatedRecoveryResources(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/recovery-resources`, { params });
        return response.data;
    }

    async addRecoveryResources(id, recoveryResourceIds) {
        const response = await this.client.post(`${this.basePath}/${id}/recovery-resources`, { recoveryResourceIds });
        return response.data;
    }

    async removeRecoveryResource(id, resourceId) {
        const response = await this.client.delete(`${this.basePath}/${id}/recovery-resources/${resourceId}`);
        return response.data;
    }

    async getRelatedRpoCalculations(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/rpo-calculations`, { params });
        return response.data;
    }

    async addRpoCalculations(id, calculationIds) {
        const response = await this.client.post(`${this.basePath}/${id}/rpo-calculations`, { calculationIds });
        return response.data;
    }

    async removeRpoCalculation(id, calculationId) {
        const response = await this.client.delete(`${this.basePath}/${id}/rpo-calculations/${calculationId}`);
        return response.data;
    }

    async getRelatedRpoRecommendations(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/rpo-recommendations`, { params });
        return response.data;
    }

    async addRpoRecommendations(id, recommendationIds) {
        const response = await this.client.post(`${this.basePath}/${id}/rpo-recommendations`, { recommendationIds });
        return response.data;
    }

    async removeRpoRecommendation(id, recommendationId) {
        const response = await this.client.delete(`${this.basePath}/${id}/rpo-recommendations/${recommendationId}`);
        return response.data;
    }

    async getRelatedDocuments(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/documents`, { params });
        return response.data;
    }

    async addDocuments(id, documentIds) {
        const response = await this.client.post(`${this.basePath}/${id}/documents`, { documentIds });
        return response.data;
    }

    async removeDocument(id, documentId) {
        const response = await this.client.delete(`${this.basePath}/${id}/documents/${documentId}`);
        return response.data;
    }

    async getRelatedRisks(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/risks`, { params });
        return response.data;
    }

    async addRisks(id, riskIds) {
        const response = await this.client.post(`${this.basePath}/${id}/risks`, { riskIds });
        return response.data;
    }

    async removeRisk(id, riskId) {
        const response = await this.client.delete(`${this.basePath}/${id}/risks/${riskId}`);
        return response.data;
    }

    async getRelatedBcps(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/bcps`, { params });
        return response.data;
    }

    async addBcps(id, bcpIds) {
        const response = await this.client.post(`${this.basePath}/${id}/bcps`, { bcpIds });
        return response.data;
    }

    async removeBcp(id, bcpId) {
        const response = await this.client.delete(`${this.basePath}/${id}/bcps/${bcpId}`);
        return response.data;
    }

    async getPartyTemplate(params = {}) {
        const response = await this.client.get(`${this.basePath}/party-template`, { params });
        return response.data;
    }

    async checkBiaIdAvailability(params = {}) {
        const response = await this.client.get(`${this.basePath}/check-bia-id`, { params });
        return response.data;
    }

    async getParty(id) {
        const response = await this.client.get(`${this.basePath}/${id}/party`);
        return response.data;
    }

    async syncParty(id, body) {
        const response = await this.client.put(`${this.basePath}/${id}/party`, body);
        return response.data;
    }

    async submit(id) {
        const response = await this.client.post(`${this.basePath}/${id}/submit`);
        return response.data;
    }
}
